import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionSectionFormatter = ({
  section
}) => {
  const ActionButtons = section.actions;
  return /*#__PURE__*/_jsx(UIButtonWrapper, {
    children: ActionButtons.map((action, idx) => {
      if (action.type === 'ACTION' || action.type === 'ACTION_V2') {
        return /*#__PURE__*/_jsx(CopilotActionButton, {
          copilotAction: action.payload,
          size: "xs",
          text: action.label,
          use: "tertiary-extra-light"
        }, idx);
      }
      return null;
    })
  });
};
export default ActionSectionFormatter;